// extracted by mini-css-extract-plugin
module.exports = {"showMoreWrapper":"_04bb2ea","showMore":"_4f55ba9"};